var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVodka({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F9EFE2;}\n\t.st3{fill:#37A836;}\n\t.st4{fill:#82BF67;}\n\t.st5{fill:#6BB055;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,183.78c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,149.49,62.06,183.78,104.75,183.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.21,151.07c-3.62,0-6.82-2.92-7.16-6.52l-6.54-69.13c-0.14-1.44,0.93-2.61,2.37-2.61h62.67 c1.45,0,2.51,1.17,2.37,2.61l-6.54,69.13c-0.34,3.6-3.55,6.52-7.16,6.52H84.21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.83,100.58l4.12,43.6c0.15,1.58,1.67,2.96,3.25,2.96h40.01c1.58,0,3.1-1.38,3.25-2.96l4.13-43.6H76.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.98,133.3l1.06,11.25c0.34,3.6,3.55,6.52,7.16,6.52h40.01c3.61,0,6.82-2.92,7.16-6.52l1.06-11.25H75.98z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.38,144.55l6.54-69.13c0.14-1.44-0.93-2.61-2.37-2.61h-16.14v78.25h4.81 C127.83,151.07,131.04,148.15,131.38,144.55z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.88,128.35h-9.17c-1.45,0-2.62-1.17-2.62-2.62v-9.17c0-1.45,1.17-2.62,2.62-2.62h9.17 c1.45,0,2.62,1.17,2.62,2.62v9.17C97.5,127.18,96.32,128.35,94.88,128.35z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.28,67.28c0.92,0.74,0.92,2.11,0.08,2.95L88.34,95.25c-0.84,0.84-2.21,0.84-2.95-0.08 c-6.28-7.79-5.8-19.23,1.44-26.46C94.06,61.47,105.49,61,113.28,67.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.86,71.74c6.06-6.06,15.93-6.06,21.99,0L89.85,93.73C83.79,87.67,83.79,77.8,89.86,71.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.85,82.74L89.86,71.74c6.06-6.06,15.93-6.06,21.99,0L100.85,82.74z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.46,
    y: 113.4,
    className: "st1",
    width: 15.53,
    height: 15.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodka);
export default __webpack_public_path__ + "static/media/Vodka.ae7391d9136e201c72d5cc29ec384117.svg";
export { ForwardRef as ReactComponent };